<template>
  <label class="toggleLabel">
    <div class="switch">
      <input type="checkbox" v-model="checked" @change="toggleActivity">
      <span class="slider round"></span>
    </div>
    <slot />
  </label>
</template>

<script>
export default {
  name: 'Toggle',
  props: {
    state: {
      default: false
    }
  },
  computed: {
    checked: {
      get () {
        return this.$props.state
      },
      set (newValue) {
        this.checkedProxy = newValue
      }
    }
  },
  methods: {
    toggleActivity () {
      let on = this.checkedProxy
      this.$emit('toggleItem', on)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/Toggle.vue